// Add your custom JS here.
(function ($) {
    // Fade in effects
    AOS.init();

    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,
    });

    // check if page is scrolled from the top for header
    $(document).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $("#wrapper-navbar").addClass("off-top");
            $(".page-nav").addClass("off-top");
        }
        if ($(this).scrollTop() < 50) {
            $("#wrapper-navbar").removeClass("off-top");
            $(".page-nav").removeClass("off-top");
        }
    });

    // show header based on scroll directions
    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $("#wrapper-navbar").addClass("hide");
            $(".page-nav").addClass("hide");
        } else {
            $("#wrapper-navbar").removeClass("hide");
            $(".page-nav").removeClass("hide");
        }
        lastScrollTop = st;
    });

    // Amenities hotel swiper
    var swiper = new Swiper(".hotelcarousel-swiper", {
        slidesPerView: "auto",
        center: true,
        loop: true,
        // pagination: {
        //     el: ".carouselname-pagination",
        //     clickable: true,
        //     renderBullet: function (index, className) {
        //         return '<span class="' + className + '"></span>';
        //     },
        // },
        navigation: {
            nextEl: ".hotelcarousel-swiper-next",
            prevEl: ".hotelcarousel-swiper-prev",
        },
    });

    // Side swiper
    var sidecontentswiper = new Swiper(".sideswiper-content", {
        slidesPerView: 1,
        center: true,
        allowTouchMove: false,
        effect: "fade",
        loop: false,
        grabCursor: false,
        // effect: 'fade',
    });

    var sideimageswiper = new Swiper(".sideswiper-images", {
        slidesPerView: 1,
        center: true,
        grabCursor: false,
        spaceBetween: 30,
        allowTouchMove: false,
        loop: false,
        speed: 300,
        effect: "creative",
        creativeEffect: {
            prev: {
                translate: [0, 0, -400],
            },
            next: {
                translate: ["100%", 0, 0],
            },
        },
    });

    $(".sideswiper-navigation .sideswiper-next").on("click", function () {
        sidecontentswiper.slideNext();
        sideimageswiper.slideNext();
    });

    $(".sideswiper-navigation .sideswiper-prev").on("click", function () {
        sidecontentswiper.slidePrev();
        sideimageswiper.slidePrev();
    });

    // Side swiper REVERTED
    var sidecontentswiperreverted = new Swiper(".sideswiper-reverted-content", {
        slidesPerView: 1,
        center: true,
        allowTouchMove: false,
        effect: "fade",
        loop: false,
        grabCursor: false,
        // effect: 'fade',
    });

    var sideimageswiperreverted = new Swiper(".sideswiper-reverted-images", {
        slidesPerView: 1,
        center: true,
        grabCursor: false,
        spaceBetween: 30,
        allowTouchMove: false,
        loop: false,
        reverseDirection: true,
        speed: 300,
        effect: "creative",
        creativeEffect: {
            prev: {
                translate: [0, 0, -400],
            },
            next: {
                translate: ["-100%", 0, 0],
            },
        },
    });

    $(".sideswiper-reverted-navigation .sideswiper-reverted-next").on(
        "click",
        function () {
            sidecontentswiperreverted.slideNext();
            sideimageswiperreverted.slideNext();
        }
    );

    $(".sideswiper-reverted-navigation .sideswiper-reverted-prev").on(
        "click",
        function () {
            sidecontentswiperreverted.slidePrev();
            sideimageswiperreverted.slidePrev();
        }
    );

    // Wide swiper
    var wideswiper = new Swiper(".wide-swiper", {
        slidesPerView: "auto",
        center: true,
        spaceBetween: 20,
        speed: 300,
        loop: true,
        pagination: {
            el: ".wide-swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
        navigation: {
            nextEl: ".wide-swiper-next",
            prevEl: ".wide-swiper-prev",
        },
        breakpoints: {
            768: {
                spaceBetween: 50,
            },
        },
    });

    // Logos swiper
    var wideswiper = new Swiper(".logos-swiper", {
        slidesPerView: "auto",
        center: true,
        speed: 300,
        loop: true,
        pagination: {
            el: ".logos-swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
        navigation: {
            nextEl: ".logos-swiper-next",
            prevEl: ".logos-swiper-prev",
        },
    });

    // Side swiper inner
    var hotelswiper = new Swiper(".sideswiper-inner-1", {
        slidesPerView: "auto",
        center: true,
        speed: 300,
        loop: false,
        pagination: {
            el: ".sideswiper-inner-pagination-1",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    var hotelswiper = new Swiper(".sideswiper-inner-2", {
        slidesPerView: "auto",
        center: true,
        speed: 300,
        loop: false,
        pagination: {
            el: ".sideswiper-inner-pagination-2",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    var hotelswiper = new Swiper(".sideswiper-inner-3", {
        slidesPerView: "auto",
        center: true,
        speed: 300,
        loop: false,
        pagination: {
            el: ".sideswiper-inner-pagination-3",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    var hotelswiper = new Swiper(".sideswiper-inner-4", {
        slidesPerView: "auto",
        center: true,
        speed: 300,
        loop: false,
        pagination: {
            el: ".sideswiper-inner-pagination-4",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    var hotelswiper = new Swiper(".sideswiper-inner-5", {
        slidesPerView: "auto",
        center: true,
        speed: 300,
        loop: false,
        pagination: {
            el: ".sideswiper-inner-pagination-5",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    var hotelswiper = new Swiper(".sideswiper-inner-6", {
        slidesPerView: "auto",
        center: true,
        speed: 300,
        loop: false,
        pagination: {
            el: ".sideswiper-inner-pagination-6",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    var hotelswiper = new Swiper(".sideswiper-inner-7", {
        slidesPerView: "auto",
        center: true,
        speed: 300,
        loop: false,
        pagination: {
            el: ".sideswiper-inner-pagination-7",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    var hotelswiper = new Swiper(".sideswiper-inner-8", {
        slidesPerView: "auto",
        center: true,
        speed: 300,
        loop: false,
        pagination: {
            el: ".sideswiper-inner-pagination-8",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    // toggle menu
    $(".menu-toggle").on("click", function () {
        $(this).toggleClass("active");
        $("#wrapper-navbar").toggleClass("active");
    });

    //faq toggle
    var action = "click";
    var speed = "500";

    $("li.q").on(action, function () {
        $(".faq li").removeClass("active");
        $(this).addClass("active");
        $(this).next().addClass("active");
        $(this).next().slideToggle(speed).siblings("li.a").slideUp();
    });

    $("li.q:first-child").addClass("active");

    // show all events
    $(".all-events").on("click", function () {
        $(this).addClass("allshown");
        $(".events").addClass("allshown");
    });

    // Lifestyle map areas/restaurants
    $(".starbucks_coffee, .starbucks_coffee").addClass("active");
    $(".Jing_Jing_Restaurant, #Jing_Jing_Restaurant").addClass("active");
    $(".eats-and-drinks.floor-tab").addClass("active");
    $(".floor.eatsdrinks").addClass("active");

    $(".floor-tab").on("click", function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");

        var tabtype = $(this).data("type");
        $(".floor").removeClass("active");
        $(".floor." + tabtype + "").addClass("active");
    });

    $("#toggles rect").on("click", function () {
        var mapitem = $(this).attr("id");

        $(this).parent().parent().parent().siblings().removeClass("active");
        $(this).siblings().removeClass("active");
        $("." + mapitem + "").addClass("active");
        $(this).addClass("active");
    });





    // plans toggle

    $(".plan-1").addClass("active");
    $(".plan-label:first-child").addClass("active");

    $(".plan-label").on("click", function () {
        var planindex = $(this).data("plan");
        $(".plan-label").removeClass("active");
        $(".plans .plan").removeClass("active");
        $(this).addClass("active");
        $(".plans .plan-" + planindex + "").addClass("active");
    });

    // number counters
    $(".counter").countUp();

    // Flow sentences
    // const textPath = document.querySelector("#textpath");
    // const h = document.documentElement,
    //     b = document.body,
    //     st = 'scrollTop',
    //     sh = 'scrollHeight';

    // var vwwidth = $(document).width();
    // document.addEventListener("scroll", e => {
    //     let percent = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
    //     textPath.setAttribute("startOffset", (-percent * 40) + vwwidth);
    // });

    // const textPath = document.querySelector("#textpath");
    // const h = document.documentElement,
    //     b = document.body,
    //     st = "scrollTop",
    //     sh = "scrollHeight";

    // var vwwidth = $(document).width();
    // document.addEventListener("scroll", (e) => {
    //     let percent =
    //         ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
    //     textPath.setAttribute("startOffset", -percent * 40);
    // });

    // frontpage block images
    $(".page-template-frontpage .block img:first-child").addClass("active");

    var handle = null;
    $(".page-template-frontpage .block").on("mouseover", function () {
        $(this).find("img.active").next().addClass("active");

        var boxes = $(this).find("img");
        console.log(boxes);
        var count = -1;
        function AddRedClass() {
            var boxLength = boxes.length - 1;
            count < boxLength ? count++ : (count = 0);
            boxes.removeClass("active").eq(count).addClass("active");
        }
        handle = setInterval(AddRedClass, 400);
    });

    $(".page-template-frontpage .block").on("mouseout", function () {
        clearInterval(handle);
        handle = 0;
    });

    // Hotel swiper
    var hotelswiper = new Swiper(".hotel-swiper", {
        slidesPerView: "auto",
        center: true,
        spaceBetween: 50,
        effect: "fade",
        loop: false,
        pagination: {
            el: ".hotel-swiper-progresbar",
            type: "progressbar",
        },
        navigation: {
            nextEl: ".hotel-swiper-next",
            prevEl: ".hotel-swiper-prev",
        },
    });

    hotelswiper.on("slideChange", function () {
        var slideIndex = hotelswiper.activeIndex + 1;
        var currentslide = "0" + slideIndex;

        $(".hotel-swiper-progresbarwrapper .currentslide").text(currentslide);
    });

    if ($(window).width() < 960) {
        hotelswiper.on("slideChange", function () {
            $("html, body").animate({ scrollTop: "-=500px" }, 800);
        });
    }

    // page sub menus
    if ($(".page-nav").length) {
        $(".page-nav li:first-child a").addClass("active");
        var stickyElem = document.querySelector(".page-nav");
        var currStickyPos =
            stickyElem.getBoundingClientRect().top + window.pageYOffset - 85;
        window.onscroll = function () {
            if (window.pageYOffset > currStickyPos) {
                stickyElem.style.position = "fixed";
                stickyElem.style.top = "85px";
                $(".page-nav").addClass("pinned");
            } else {
                stickyElem.style.position = "absolute";
                stickyElem.style.top = "25px";
                $(".page-nav").removeClass("pinned");
            }
        };

        $(window).on("scroll", function () {
            $(".anchor").each(function () {
                if ($(window).scrollTop() >= $(this).offset().top - 50) {
                    var currentItem = $(this).attr("id");
                    $(".page-nav a").removeClass("active");
                    $("." + currentItem).addClass("active");
                }
            });
        });
    }

    $(".page-nav a").on("click", function () {
        $(".page-nav a").removeClass("active");
        $(this).addClass("active");
    });

    // lifestyle extra subnav functionalities
    $(".page-template-lifestyle .page-anchor-2").on("click", function () {
        $(this).parents().siblings().children().removeClass("active");
        $(this).addClass("active");
        $(".eats-and-drinks, .eatsdrinks").removeClass("active");
        $(".shops").addClass("active");
        $(".text #page-anchor-3").insertBefore(".text #page-anchor-2");
    });

    $(".page-template-lifestyle .page-anchor-3").on("click", function () {
        $(this).parents().siblings().children().removeClass("active");
        $(this).addClass("active");
        $(".shops").removeClass("active");
        $(".eats-and-drinks, .eatsdrinks").addClass("active");
        $(".text #page-anchor-2").insertBefore(".text #page-anchor-3");
    });

    // hotels extra subnav functionalities
    $(".page-template-hotels .page-anchor-1").on("click", function () {
        hotelswiper.slideTo(0, 600);
        $("#page-anchor-1").insertAfter(".section-three .anchor:nth-child(3)");
    });

    $(".page-template-hotels .page-anchor-2").on("click", function () {
        hotelswiper.slideTo(1, 600);
        $("#page-anchor-2").insertAfter(".section-three .anchor:nth-child(3)");
    });

    $(".page-template-hotels .page-anchor-3").on("click", function () {
        hotelswiper.slideTo(2, 600);
        $("#page-anchor-3").insertAfter(".section-three .anchor:nth-child(3)");
    });

    // make fullscreen vimeo popup if button contains vimeo iframe link
    $('.button[href*="player.vimeo"').each(function () {
        $(this).addClass("hasvimeo");
        var Index = $(this).index();
        var videoLink = $(this).attr("href");
        var buttonTex = $(this).text();
        $(
            '<div class="vimeopopupvideo button-video-popup video-popup-' +
                Index +
                '"><div class="close"></div><iframe src="' +
                videoLink +
                '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>'
        ).insertAfter(".fold, .fold-inverted");
        $(this).replaceWith(
            '<span class="button button-' +
                Index +
                ' darkblue hasvimeo">' +
                buttonTex +
                "</span>"
        );
    });

    hotelswiper.on("slideChange", function () {
        if ($(".hotel-swiper-next").hasClass("swiper-button-disabled")) {
            $(".page-nav a").removeClass("active");
            $(".page-anchor-3").addClass("active");
        } else if ($(".hotel-swiper-prev").hasClass("swiper-button-disabled")) {
            $(".page-nav a").removeClass("active");
            $(".page-anchor-1").addClass("active");
        } else {
            $(".page-nav a").removeClass("active");
            $(".page-anchor-2").addClass("active");
        }
    });

    // open vimeo popup videos
    $(".hasvimeo").on("click", function () {
        var buttonid = $(this).index();
        $(".video-popup-" + buttonid + "").addClass("active");
    });

    // close vimeo popup videos
    $(".vimeopopupvideo").on("click", function () {
        $(this).removeClass("active");
        var iframe = $(this).children("iframe")[0].contentWindow;
        iframe.postMessage('{"method":"pause"}', "*");
    });

    // make fullscreen youtube popup if button contains youtube iframe link
    $('.button[href*="youtube.com/embed"').each(function () {
        $(this).addClass("hasyoutube");
        var Index = $(this).index();
        var videoLink = $(this).attr("href");
        var buttonTex = $(this).text();
        $(
            '<div class="youtubepopupvideo button-video-popup video-popup-' +
                Index +
                '"><div class="close"></div><iframe width="560" height="315" src="' +
                videoLink +
                '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>'
        ).insertAfter(".fold, .fold-inverted");
        $(this).replaceWith(
            '<span class="button button-' +
                Index +
                ' darkblue hasyoutube">' +
                buttonTex +
                "</span>"
        );
    });

    // open youtube popup videos
    $(".hasyoutube").on("click", function () {
        var buttonid = $(this).index();
        $(".video-popup-" + buttonid + "").addClass("active");
    });

    // close youtube popup videos
    $(".youtubepopupvideo").on("click", function () {
        $(this).removeClass("active");

        var video = $(this).children("iframe").attr("src");
        $(this).children("iframe").attr("src", "");
        $(this).children("iframe").attr("src", video);
    });

    // $("#departures div span:last-child").each(function () {
    //     $(this).addClass("hoi");
    // });

    //mute video

    $(".mute").click(function () {
        if ($("video").prop("muted")) {
            $("video").prop("muted", false);
        } else {
            $("video").prop("muted", true);
        }
        $(".mute").toggleClass("active");
    });

    //hotel swiper params for third slide

    let searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has("sent")) {
        hotelswiper.slideTo(3);
    }





    // hide events if there is none
    if(!$('.page-template-whats-on .section-six').length){
        $(".page-nav li:last-child").addClass('hide');
    }



})(jQuery);
